import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";
import Table from "./table.react";
import Select from "react-select";

export default class Order extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      notificationSystem,
      params: { uid }
    } = this.props;
    actions.getOrder(uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  updateOrder = () => {
    const {
      actions,
      orders: {
        orders: { entities: orders }
      },
      params: { uid },
      notificationSystem
    } = this.props;
    const order = orders.get(uid);
    actions.updateOrder(order.toJS(), uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  };

  onStatusSelect = value => {
    const {
      actions,
      params: { uid }
    } = this.props;
    actions.setEntityField("orders", uid, "status", value);
  };

  render() {
    const {
      actions,
      orders: {
        orders: { entities: orders }
      },
      params: { uid }
    } = this.props;
    const order = orders ? orders.get(uid) : null;
    const inputCustomCustomProps = order
      ? {
          feature: "orders",
          actions: actions,
          entity: order,
          uid: order ? order.get("uid") : null
        }
      : {
          feature: "orders",
          actions: actions,
          entity: order,
          uid: undefined
        };

    const orderStatusSelectOptions = [
      {
        value: "awaiting shipment",
        label: "Przygotowanie paczki"
      },
      {
        value: "awaiting delivery",
        label: "Wysłano paczkę"
      },
      {
        value: "delivered",
        label: "Dostarczono paczkę"
      },
      {
        value: "canceled",
        label: "Anulowno zamówienie"
      },
      {
        value: "complaint",
        label: "Reklamacja"
      }
    ];

    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <h2>Zamówienie nr {order ? order.get("orderID") : ""}</h2>
            <div className="box-wrapper">
              <div className="title">Dane kontrahenta</div>
              <div className="content-wrapper">
                <div className="row middle-xs">
                  <div className="col-xs-4 col-lg-2">
                    <label>Imię</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["firstName"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Nazwisko</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["lastName"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Ulica</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["street"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Miasto</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom field={["city"]} {...inputCustomCustomProps} />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Kod pocztowy</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom field={["code"]} {...inputCustomCustomProps} />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Telefon</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["phone"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Email</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["email"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Status zamówienia</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <Select
                      name="select-media-category"
                      value={order ? order.get("status") : ""}
                      options={orderStatusSelectOptions}
                      onChange={this.onStatusSelect}
                      clearable={false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="box-wrapper">
              <div className="title">Dane do faktury</div>
              <div className="content-wrapper">
                <div className="row middle-xs">
                  <div className="col-xs-4 col-lg-2">
                    <label>Nazwa firmy</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["companyName"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Adres</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["companyAddress"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Miasto</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["companyCity"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>Kod pocztowy</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom
                      field={["companyCode"]}
                      {...inputCustomCustomProps}
                    />
                  </div>
                  <div className="col-xs-4 col-lg-2">
                    <label>NIP</label>
                  </div>
                  <div className="col-xs-8 col-lg-4">
                    <InputCustom field={["nip"]} {...inputCustomCustomProps} />
                  </div>
                </div>
              </div>
            </div>
            <div className="box-wrapper">
              <div className="title">Produkty</div>
              <div className="content-wrapper">
                <Table products={order ? order.get("products") : null} />
              </div>
            </div>
            <button className="info" onClick={this.updateOrder}>
              zatwierdź zmiany
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/order/order.react.js